var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"poster-img",attrs:{"src":_vm.posterSrc,"alt":"poster"}}),_vm._v(" "),_c('play-button-mask',{on:{"click":function($event){return _vm.$emit('click')}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fc2aedf6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SlideFragment/slideComponents/VideoPlayer/VideoPlayerPreview.vue
// module id = 128
// module chunks = 0